import { tenantConstants } from "./constants/tenantConstants";

const getTenantList = (data: any) => ({
  type: tenantConstants.getTenantListRequest,
  payload: data,
});

const getHeaderTenantList = (data: any) => ({
  type: tenantConstants.getHeaderTenantListRequest,
  payload: data,
});

const saveTenant = (data: any) => ({
  type: tenantConstants.tenantSaveRequest,
  payload: data,
});

const viewTenant = (data: any) => ({
  type: tenantConstants.tenantViewRequest,
  payload: data,
});

const getAccessControl = (tenantId: string) => ({
  type: tenantConstants.getAccessControlRequest,
  payload: tenantId,
});

const saveAccessControl = (data: any) => ({
  type: tenantConstants.saveAccessControlRequest,
  payload: data,
});

export const tenantActions = {
  getTenantList,
  getHeaderTenantList,
  saveTenant,
  viewTenant,
  getAccessControl,
  saveAccessControl,
};
